export const pageItems = [15, 25, 50];
export const defaultItems = 15;
export const dummyPages = [1, 2, 3, 4, 5, 6, 7, 8, 9];
